import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { UserPlatform } from '@classes/user/user-platform';
import { faInfoCircle, faSearch, faCar, faPlus, faUser, faPen, faTrashAlt, faUserPlus, faTimes, faChartPie } from '@fortawesome/free-solid-svg-icons';
import { DataService } from '@services/data/data.service';
import { UsersService } from '@services/users/users.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { UserUpdateComponent } from '../user-update/user-update.component';
import { UsersAddComponent } from '../users-add/users-add.component';
import { UsersDeleteComponent } from '../users-delete/users-delete.component';


@Component({
  selector: 'app-users-management',
  templateUrl: './users-management.component.html',
  styleUrls: ['./users-management.component.scss']
})
export class UsersManagementComponent extends SubscriptionBaseComponent implements OnInit {

  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faCar = faCar;
  faPlus = faPlus;
  faUser = faUser;
  faPen = faPen;
  faTrashAlt = faTrashAlt;
  faUserPlus = faUserPlus;
  faTimes = faTimes;
  faChartPie = faChartPie;

  searchForm: FormGroup;

  displayedColumns: string[] = ['username', 'lastname', 'firstname', 'role', 'statut', 'editer', 'details'];
  dataSource: MatTableDataSource<UserPlatform>;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  isAdmin: boolean;

  statusUser = ['Tous', 'Actif', 'Inactif'];
  statusUserSelected = 'Actif'


  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  show = false;
  users: UserPlatform[];
  filterValue: string;
  usersList: UserPlatform[];


  constructor(
    private dialog: MatDialog,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    public router: Router,
    private userService: UsersService,
    private formBuilder: FormBuilder
  ) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.initSub();
    this.getUsers();
  }

  applyFilter(filterValue): void {
    this.filterValue = filterValue;

    let filterWord = '';
    switch (filterValue) {
      case 'actif':
        filterWord = 'true';
        break;
      case 'inactif':
        filterWord = 'false';
        break;
      default:
        filterWord = filterValue;
        break;
    }

    this.dataSource.filter = filterWord.trim().toLowerCase();
  }


  openDialogAddUser(): void {
    const users = this.users;
    const dialogRef = this.dialog.open(UsersAddComponent);

    dialogRef.afterClosed().subscribe(res => {
      this.getUsers();
    });
  }


  showElement(): void {
    setTimeout(() => {
      this.show = true;
    }, 150);
  }

  getUsers(): void {
    this.userService.getUser().subscribe(res => {
      this.usersList = res;
      this.filterUser();
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'role': return item.role.name;
          case 'statut': return item.isActive;
          default: return item[property];
        }
      };

      this.dataSource.filterPredicate = (data: any, filter) => {
        const dataStr = JSON.stringify(data).toLowerCase(); return dataStr.indexOf(filter) !== -1;
      };

      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  openDialogUpdatePwdUser(userdetails): void {
    const dialogRef = this.dialog.open(UserUpdateComponent, {
      data: {
        user: userdetails
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      this.getUsers();

    });
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.applyFilter('');
  }

  filterUser(event?): void {
    if (event) {
      this.statusUserSelected = event;
    }

    switch (this.statusUserSelected) {
      case 'Tous':
        this.dataSource = new MatTableDataSource<UserPlatform>(this.usersList);
        break;
      case 'Actif':
        const userActive = this.usersList.filter(user => user.isActive)
        this.dataSource = new MatTableDataSource<UserPlatform>(userActive);
        break;
      case 'Inactif':
        const userInactive = this.usersList.filter(user => !user.isActive)
        this.dataSource = new MatTableDataSource<UserPlatform>(userInactive);
        break;

      default:
        break;
    }

    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }
  private initSub(): void {
    this.subscription
      .add(
        this.dataService.isAdmin.asObservable().subscribe(isAdmin => {
          this.isAdmin = isAdmin;
          this.cdr.detectChanges();
        })
      );

  }
}
